import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';

import {
  ECostBearer,
  EProductUseType,
  ESettlementTarget,
} from '../../../schema/types';
import {
  DELIVERY_FEE_BEARER_OPTIONS,
  DELIVERY_FEE_SETTLEMENT_TARGET,
} from '../const';
import { UpdatePromotionEventFormValues } from '../types';

const ERROR_MESSAGE = '필수항목이 입력되지 않았습니다.';

const delivery = {
  isDeliveryFee: yup.boolean().required(),
  deliveryFee: yup.number().optional().nullable(),
  deliveryFeeBearer: yup
    .mixed<ECostBearer>()
    .oneOf(DELIVERY_FEE_BEARER_OPTIONS.map(({ value }) => value))
    .when('isDeliveryFee', {
      is: true,
      then: (schema) => schema.required(ERROR_MESSAGE),
      otherwise: (schema) => schema.optional().nullable(),
    }),
  deliveryFeeSettlementPrice: yup.number().optional().nullable(),
  deliveryFeeSettlementTarget: yup
    .mixed<ESettlementTarget>()
    .oneOf(DELIVERY_FEE_SETTLEMENT_TARGET.map(({ value }) => value))
    .when('isDeliveryFee', {
      is: true,
      then: (schema) => schema.required(ERROR_MESSAGE),
      otherwise: (schema) => schema.optional().nullable(),
    }),
};

const promotionProduct = {
  useType: yup
    .mixed<EProductUseType>()
    .oneOf(['FIX', 'SELECT'])
    .optional()
    .nullable(),
  setCount: yup.number().required(ERROR_MESSAGE),
  isFreeProvided: yup.boolean().required(),
  originalProductId: yup
    .mixed<string | number>()
    .required('품목을 등록해주세요.'),
  promotionItems: yup
    .array()
    .of(yup.object({ originalItemId: yup.number().required() }))
    .when('useType', ([useType], schema) =>
      useType === 'SELECT'
        ? schema.required().min(1, '옵션을 등록해주세요.')
        : schema.optional().nullable()
    ),
};

const updatePromotionSchema = yup.object().shape({
  id: yup.number().required(),
  originalProductGroupId: yup.number().required(),
  productGroupId: yup.number().optional().nullable(),
  marketUndesignated: yup.boolean().optional().nullable(),
  marketId: yup.number().when('marketUndesignated', {
    is: true,
    then: (schema) => schema.optional().nullable(),
    otherwise: (schema) => schema.required(ERROR_MESSAGE),
  }),
  promotionProducts: yup
    .array()
    .of(yup.object(promotionProduct))
    .required()
    .min(1, '상품(품목)을 추가해주세요.'),
  ...delivery,
});

export const updatePromotionResolver =
  yupResolver<UpdatePromotionEventFormValues>(updatePromotionSchema);
